export default __webpack_public_path__ + "static/media/artist-sm.77debe23.jpg";